import React, { forwardRef } from 'react';
import classNames from 'classnames';
import {
  oneOf,
} from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { buildImageURL } from '../../../utils/product-add-on-utils';
import { ICONS } from '../../../utils/product-add-on-constants';
import '../../tooltip.scss';

const ProReferralTooltip = forwardRef(({ channel, size }, buttonRef) => {
  const toolTipLabelClasses = classNames({
    'u__default-link': true,
    'product-add-on-tooltip-content__label': true,
    scrollTouch: size === 'large',
  });
  const proReferralLogo = ICONS.proReferralIcon;
  const tooltipContent = (
    <div className="product-add-on-tooltip-content" data-channel={`${channel}`}>
      <div className="product-add-on-tooltip-content__header"><b>Why Choose Pro Referral?</b></div>
      <ul className="product-add-on-tooltip-content__list">
        <li>Get connected to the pro that&apos;s right for you and your budget</li>
        <li>No mess - Pros clean up when finished</li>
        <li>Reduce stress and save time</li>
      </ul>
      <div>
        <div className="product-add-on-tooltip-content__sub-heading">What to Expect</div>
        <div className="product-add-on-tooltip-content__pro-referral-legal">
          <p>
            After completing your purchase, you&apos;ll be contacted
            by 1-3 Pro Referral pros, choose the pro that&apos;s best
            for your job and work with them directly to set up your appointment.
          </p>
          <p>
            Please note that by continuing with this option, you consent to be
            contacted via phone by local pros, and you agree to the&nbsp;
            <a
              className="u__default-link"
              href="https://www.proreferral.com/about/legal/tos/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Pro Referral Terms of Service
            </a>
          </p>
        </div>
        <p className="product-add-on-tooltip-content__logo">
          <img
            alt="Pro Referral Icon"
            className="product-add-on-tooltip-content__logo__img-styling"
            src={buildImageURL(proReferralLogo)}
          />
        </p>
      </div>
    </div>
  );
  return (
    <Tooltip channel={channel} placement="bottom" content={tooltipContent} closeButton>
      <button type="button" ref={buttonRef} className={toolTipLabelClasses}>
        What to Expect
        <img
          src={buildImageURL(ICONS.info)}
          alt="information tooltip"
          className="product-add-on-tooltip-content__label__suffix"
        />
      </button>
    </Tooltip>
  );
});

ProReferralTooltip.displayName = 'ProductAddOns-proReferral-tooltip';

ProReferralTooltip.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
  /** Render large or small version */
  size: oneOf(['large', 'small']),
};

ProReferralTooltip.defaultProps = {
  channel: 'desktop',
  size: 'large',
};

export { ProReferralTooltip };
